
<template>
  <div class="record_box"
       style="height:100%;">
    <div class="bg"
         v-if="balanceList.length>0"></div>
    <div ref="mescroll"
         v-show="balanceList.length>0"
         class="mescroll noticeBox">
      <div>
        <div class="record_item"
             id="noticeList">
          <div class="item"
               v-for="(item,idx) in balanceList"
               :key="idx">
            <img class="logo"
                 :src="item.imgUrl" />
            <div class="info">
              <p class="title">{{item.description}}</p>
              <p class="time">{{item.gmtCreate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Empty :propJson="propJson"
           v-show="balanceList.length==0" />
  </div>
</template>

<script>
import Empty from '@/components/empty'
import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
export default {
  components: {
    MeScroll,
    Empty
  },
  data () {
    return {
      propJson: {
        title: '金币已经领完啦~快去赚金币吧！',
      },
      customerId: '',
      balanceList: [],
      page: 1,
      pageSize: 10,
      mescroll: null, //mescroll实例对象
    }
  },
  mounted () {
    this.util.title('我的奖品');
    this.customerId = this.$route.query.customerId
    let _this = this;
    // this.getBalanceList();
    _this.mescroll = new MeScroll(_this.$refs.mescroll, { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      up: {
        auto: true,
        callback: _this.getBalanceList, //上拉回调
        page: {
          size: 10
        },
        clearEmptyId: 'noticeList',
        offset: 10,
        noMoreSize: 3,
        htmlNodata: '<p class="upwarp-nodata">-- End --</p>'
      },
      down: {
        auto: false,//自动加载
        isBounce: false,
        callback: _this.downCallback
      }
    });
  },
  methods: {
    /**
            * 下拉刷新
            */
    downCallback () {
      this.balanceList = []//重置数组
      //下拉刷新的回调
      this.mescroll.resetUpScroll();
    },
    getBalanceList (page) {
      let _this = this;
      let param = {
        customerId: this.customerId,
        pageNum: page.num,
        pageSize: this.pageSize,
      }
      this.$get('/app/valueAdded/lotteryRecords', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            //产品分页
            let productList = e.data.data;
            _this.mescroll.endBySize(productList.length, e.data.total);
            _this.balanceList = _this.balanceList.concat(productList);
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { console.log('错误') });
    }

  }

}
</script>
<style scoped>
.bg {
  width: 100%;
  height: 0.1rem;
  background: #f7f7f7;
}
.bgAct {
  background: #f7f7f7;
}
/* 非vip样式 */
.mescroll {
    position: fixed;
    padding-bottom: 1rem;
    top: 2px;
    bottom: 0;
    height: auto;
  -webkit-overflow-scrolling: touch;
}
.record_box {
  font-family: PingFangSC-Regular;
  background: #fff;
  /* padding: 0 0.15rem; */
}
.bal_money {
  font-family: DINAlternate-Bold;
  font-size: 0.4rem;
  color: #fff;
  position: relative;
  top: -0.06rem;
}
.balance {
  color: #fff;
  font-size: 0.12rem;
}
.dw {
  font-size: 0.14rem;
  top: -0.03rem;
  font-size: 0.14rem;
  position: relative;
  left: -0.06rem;
}
.record_item {
  padding: 0 0.15rem;
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  font-size: 0.14rem;
  padding: 0.12rem 0;
}
.item .title {
  color: #333;
  font-size: 0.14rem;
  font-weight: 500;
}
.item .time {
  color: #999;
  margin-top: 0.02rem;
}
.logo {
  display: inline-block;
  width: 0.36rem;
  height: 0.36rem;
  position: relative;
  top: 0.02rem;
}
.info {
  flex: 0.94;
  /* margin-left: 0.2rem; */
}
</style>
